import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="settings--labels"
export default class extends Controller {
  static targets = [
    'kind',
    'parent',
    'parentFields',
    'prefix',
    'systemFields',
    'packageRadio',
    'customRadio',
    'packageFields',
    'customFields',
    'softwareTypeField']

  static values = {
    parents: {
      type: Array,
      default: ['procedure_group', 'process_group']
    },
    procedureGroups: Array,
    processGroups: Array
  }

  connect () {
    // Show/hide fields on initial load
    this.toggleParentFields()
    this.toggleSystemFields()
    this.toggleSoftwareType()
  }

  kindChanged (event) {
    const hasParent = this.parentsValue.includes(this.kindTarget.value)
    const ts = this.parentTarget.tomselect

    if (hasParent) {
      ts.clear()
      ts.clearOptions()
      ts.addOption({ value: '', text: 'None (top-level)' })
      this[`${toCamelCase(this.kindTarget.value)}sValue`].forEach((item) => {
        ts.addOption({ value: String(item[0]), text: item[1], code: item[2] })
      })
      ts.setValue('', true)
      ts.enable()
    } else {
      ts.clear()
      ts.disable()
    }

    this.updateCodePrefix()

    // Show/hide fields when kind changes
    this.toggleParentFields()
    this.toggleSystemFields()
  }

  parentChanged () {
    this.updateCodePrefix()
  }

  updateCodePrefix () {
    const selectedId = this.parentTarget.tomselect.getValue()
    if (!selectedId) {
      this.prefixTarget.textContent = ''
      return
    }

    const kind = this.kindTarget.value
    if (!this.parentsValue.includes(kind)) return

    const groups = this[`${toCamelCase(kind)}sValue`]
    const group = groups.find(item => String(item[0]) === selectedId)
    this.prefixTarget.textContent = group ? `${group[2]}-` : ''
  }

  toggleParentFields () {
    const hasParent = this.parentsValue.includes(this.kindTarget.value)
    this.parentFieldsTargets.forEach(field => {
      field.style.display = hasParent ? '' : 'none'
    })
  }

  toggleSystemFields () {
    const isSystem = this.kindTarget.value === 'system'
    this.systemFieldsTargets.forEach(field => {
      field.style.display = isSystem ? '' : 'none'
    })
  }

  toggleSoftwareType () {
    if (!this.hasPackageRadioTarget || !this.hasCustomRadioTarget) return

    const isPackage = this.packageRadioTarget.checked
    const isCustom = this.customRadioTarget.checked

    // Update the hidden software_type field
    if (this.hasSoftwareTypeFieldTarget) {
      this.softwareTypeFieldTarget.value = isPackage ? 'package' : 'custom'
    }

    // Show/hide package fields
    if (this.hasPackageFieldsTarget) {
      if (isPackage) {
        this.packageFieldsTarget.classList.remove('hidden')
      } else {
        this.packageFieldsTarget.classList.add('hidden')
      }
    }

    // Show/hide custom fields
    if (this.hasCustomFieldsTarget) {
      if (isCustom) {
        this.customFieldsTarget.classList.remove('hidden')
      } else {
        this.customFieldsTarget.classList.add('hidden')
      }
    }
  }
}

function toCamelCase (str) {
  return str.toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase())
}
